<!-- ----------------------------------------------- -->
<template>
  <v-col
    class="tm-mb-frame-content"
    v-if="tmSnowList.length !== 0 && tmSnowList.tmSnwDetailInfo.ofcCd"
  >
    <tm-snow-info></tm-snow-info>
    <v-card class="com-mb-card tm-mb-datail-card">
      <div class="com-mb-card-contents">
        <div class="tm-mb-detail-tab-btn">
          <v-btn
            class="vc-tab-btn"
            small
            depressed
            :class="{ 'btn-on': tabIndex === 0 }"
            @click="tabIndex = 0"
            >{{ text.tab.graph }}</v-btn
          >
          <v-btn
            class="vc-tab-btn"
            small
            depressed
            :class="{ 'btn-on': tabIndex === 1 }"
            @click="setTabIndex(1)"
            v-show="hasValues"
            >{{ text.tab.list }}</v-btn
          >
        </div>
        <div class="tm-box-list" ref="graphFrame">
          <div v-if="tabIndex === 0">
            <!-- 拡大表示 -->
            <tm-snow-graph-dlg
              v-if="modalDiag"
              @close="closeModal"
              :isExpansion="scalMode"
              :isLegend="isLegendDisp"
            ></tm-snow-graph-dlg>
            <v-touch v-on:doubletap="openModal">
              <tm-snow-graph
                :width="graphWidth"
                :isExpansion="scalMode"
                :isLegend="isLegendDisp"
              ></tm-snow-graph>
            </v-touch>
          </div>
        </div>
        <tm-snow-values v-if="tabIndex === 1"></tm-snow-values>
        <tm-switch-btn :tabIndex="tabIndex"></tm-switch-btn>
      </div>
    </v-card>
    <tm-snow-curt></tm-snow-curt>
  </v-col>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [MB]積雪 フレーム
 * TmSnowFrame.vue
 * @author ILUKE
 */

import TmSnowInfo from "./TmSnowInfo.vue";
import TmSnowCurt from "./TmSnowCurt.vue";
import TmSnowGraph from "./TmSnowGraph.vue";
import TmSnowGraphDlg from "./TmSnowGraphDlg.vue";
import TmSnowValues from "./TmSnowValues.vue";
import TmSwitchBtn from "./TmSwitchBtn.vue";
import PageLog from "./../../lib/pageLog.js";

export default {
  name: "tm-snow-frame",
  components: {
    TmSnowInfo,
    TmSnowCurt,
    TmSnowGraph,
    TmSnowGraphDlg,
    TmSnowValues,
    TmSwitchBtn,
  },
  data() {
    return {
      /** 観測詳細タブ */
      tabIndex: 0,
      /** 文字列リソース */
      text: {
        title_detail: "観測詳細",
        title_curt: "最新観測値",
        tab: {
          graph: "グラフ",
          list: "観測値",
        },
      },
      modalDiag: false,
      graphWidth: 350,
    };
  },
  created: function () {
    this.loadTmObs();
    window.addEventListener("resize", this.handleResize);
  },
  mounted() {
    this.handleResize();
  },
  updated() {
    this.handleResize();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    // アクセスログ用パラメータ破棄
    this.$store.commit("Telemeter/setPageLogParam", null);
  },
  computed: {
    // リクエストパラメータ
    reqParam: {
      get() {
        return this.$store.state.Telemeter.selectedTmParam;
      },
    },
    /** 対象日時 */
    appTime: {
      get() {
        return this.$store.state.app.appTime;
      },
    },
    /** 観測日時(ファイル取得用) */
    appTimeRound: {
      get() {
        return this.$store.state.app.appTimeRound;
      },
    },
    // 積雪取得
    tmSnowList: {
      get() {
        return this.$store.state.Telemeter.selectedTm;
      },
    },
    // 拡縮表示設定 取得
    scalMode: {
      get() {
        return this.$store.state.Telemeter.scalMode;
      },
      set(val) {
        this.$store.commit("Telemeter/setScalMode", val);
      },
    },
    // 表示時刻設定 取得
    timeMode: {
      get() {
        return this.$store.state.Telemeter.timeMode;
      },
      set(val) {
        this.$store.commit("Telemeter/setTimeMode", val);
      },
    },
    /** 凡例表示状態 取得 */
    isLegendDisp: {
      get() {
        return this.$store.state.Telemeter.isLegendDisp;
      },
      set(val) {
        this.$store.commit("Telemeter/setLegendDisp", val);
      },
    },
    /* アクセスログ出力用パラメータ */
    pageLogParam: {
      get() {
        if (
          this.$store.state.Telemeter.pageLogParam &&
          this.$store.state.Telemeter.pageLogParam.obsData
        ) {
          return {
            prefCd:
              this.$store.state.Telemeter.pageLogParam.obsData.obsInfo.prefCd,
            twnCd:
              this.$store.state.Telemeter.pageLogParam.obsData.obsInfo.twnCd,
            rvrCd:
              this.$store.state.Telemeter.pageLogParam.obsData.obsInfo.rvrCd,
            obsCd: this.$store.state.Telemeter.pageLogParam.payload.obsFcd,
            appTime: this.$store.state.Telemeter.pageLogParam.payload.appTime,
          };
        }
        return null;
      },
    },
    // 簡易版判定
    isReduction: {
      get() {
        return global.KWB_MODE == "reduction";
      },
    },
    // 観測値を持っているか
    hasValues: {
      get() {
        if (this.tmSnowList.obsValues.hour.values.length > 0) {
          return true;
        }
        return false;
      },
    },
  },
  watch: {
    tmSnowList() {
      // データが0件の場合はフッタを表示しない
      let flg = false;
      if (
        this.tmSnowList.length !== 0 &&
        this.tmSnowList.graph.hour.value.length > 0
      ) {
        flg = true;
      }
      this.$emit("dispTmContentsSwitch", flg);
    },
    // 観測日時を監視
    appTimeRound() {
      this.loadTmObs();
    },
    // 観測所遷移 監視
    $route(to, from) {
      if (this.checkUrlParam(to, from)) {
        this.loadTmObs();
      }
    },
    /* アクセスログ出力用パラメータ */
    pageLogParam(to, from) {
      if (
        to &&
        (!from || to.obsCd != from.obsCd || to.appTime != from.appTime)
      ) {
        // アクセスログ出力
        PageLog.log({
          page_log: "snow",
          pref_cd: to.prefCd,
          twn_cd: to.twnCd,
          rvr_cd: to.rvrCd,
          obs_cd: to.obsCd,
          device_sb: this.$store.state.app.mode,
          fc_flg: this.$store.getters["app/isFldCtl"],
        });
      }
    },
  },
  methods: {
    openModal() {
      this.modalDiag = true;
    },
    closeModal() {
      this.modalDiag = false;
    },
    // 積雪を取得
    getTmSnowDatas() {
      setTimeout(() => {
        this.$store.dispatch("Telemeter/getSelectedTm", {
          ofcCd: this.reqParam.ofcCd,
          itmkndCd: this.reqParam.itmkndCd,
          obsCd: this.reqParam.obsCd,
          appTime: this.appTime,
          appTimeRound: this.appTimeRound,
        });
      }, 500);
    },
    /**
     * 画面更新処理
     */
    loadTmObs() {
      // 選択中テレメータ情報クリア
      this.$store.commit("Telemeter/setSelectedTm", []);
      // グラフ状態クリア
      this.$store.commit("Telemeter/resetTmObs");
      this.$store.commit("Telemeter/setTimeMode", null);
      // お知らせ・河川予警報ダイアログ非表示
      this.$store.commit("map/hideInfoRw");
      this.getTmSnowDatas();
    },
    // URLパラメータチェック
    checkUrlParam(to, from) {
      if (
        from.query.fld !== to.query.fld ||
        from.query.ofcCd !== to.query.ofcCd ||
        from.query.itmkndCd !== to.query.itmkndCd ||
        from.query.obsCd !== to.query.obsCd
      ) {
        return true;
      }
      return false;
    },
    handleResize() {
      this.$nextTick(() => {
        if (this.$refs.graphFrame !== undefined) {
          const offsetWidth = this.$refs.graphFrame.offsetWidth;
          if (offsetWidth > 0) {
            this.graphWidth = offsetWidth - 8;
          }
        }
      });
    },
    setTabIndex(tabIndex) {
      this.tabIndex = tabIndex;
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped></style>
